import React, { useState, useEffect } from 'react';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box'; // Import Box for better layout control

const StaticCalendarDatePicker = ({ selectedDate, onDateChange }) => {
  const [value, setValue] = useState(selectedDate || DateTime.now());

  useEffect(() => {
    if (!value.equals(selectedDate)) {
      setValue(selectedDate);
    }
  }, [selectedDate]);

  const handleDateChange = (newDate) => {
    setValue(newDate); // Update internal state
    onDateChange(newDate); // Propagate the date change to parent
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="da">
      <Box sx={{ width: '100%', maxWidth: 300}}> {/* Control width and centering */}
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          openTo="day" // You can start from "month" if preferred
          views={['year', 'month', 'day']} // Allow selecting year, month, and day
          value={value}
          onChange={handleDateChange}
          renderInput={(params) => <TextField {...params} />}
          sx={{
            backgroundColor: 'transparent',
            '& .MuiPickersCalendarHeader-labelContainer': {
              fontWeight: 'bold',
              fontSize: '1.2rem',
              textTransform: 'capitalize',
            },
            '& .MuiPickerStaticWrapper-root': {
              width: '100%' // Ensure the calendar does not overflow
            },
            // Customize selected date
            '& .Mui-selected': {
              backgroundColor: 'hsl(63, 100%, 40%) !important' , // Change to desired color
              color: '#fff', // Text color
              borderRadius: '5px', // Circular border radius for current date
            },
            '& .Mui-selected:hover': {
              backgroundColor: 'hsl(63, 100%, 45%) !important', // Change to desired color
              color: '#fff', // Text color
              borderRadius: '5px', // Circular border radius for current date
            },
            // Customize current date
            '& .MuiPickersDay-today': {
              border: '1px solid hsl(63, 100%, 40%)', // Change border color for the current date
              borderRadius: '5px', // Circular border radius for current date
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default StaticCalendarDatePicker;